// Datos de la Contadora Pública Colegiada

export const contadoraData = {
  nombre: "Eliana Rosmery Espilco Pérez",
  titulo: "Contadora Pública Colegiada"
};

export const heroData = {
  badge: "100% Online",
  title: "CPC Eliana Espilco",
  subtitle: "Servicios contables y tributarios 100% online",
  description: "Ordena tu contabilidad, cumple con SUNAT y toma mejores decisiones financieras sin salir de casa.",
  specialties: [
    "Consultora de Auditoría Tributaria",
    "Consultoría Tributaria y Estrategia Fiscal para Empresas",
    "Liderazgo y Desarrollo de Equipos",
    "Consultora de Programación Multianual de Bienes, Servicios y Obras"
  ],
  tagline: "Acompaño a las organizaciones en la comprensión y gestión eficiente de sus obligaciones tributarias.",
  highlights: [
    "Atención a emprendedores, MYPES y profesionales independientes",
    "Servicio remoto, rápido y confiable"
  ],
  ctaText: "Solicita una asesoría gratuita"
};

export const aboutData = {
  title: "¿Quién soy?",
  name: "Eliana Rosmery Espilco Pérez",
  description: "Soy Contadora Pública Colegiada, con experiencia en contabilidad, tributación y asesoría financiera para negocios y personas naturales. Mi objetivo es que te concentres en hacer crecer tu negocio mientras yo me encargo de tu contabilidad.",
  features: [
    "Atención personalizada",
    "Comunicación clara y sin tecnicismos",
    "Confidencialidad garantizada"
  ]
};

export const servicesData = [
  {
    id: 1,
    icon: "Calculator",
    title: "Contabilidad y Tributación",
    items: [
      "Declaraciones mensuales y anuales",
      "PDT, PLAME y libros electrónicos",
      "Cálculo de impuestos",
      "Regularización contable"
    ]
  },
  {
    id: 2,
    icon: "Briefcase",
    title: "Asesoría para Negocios",
    items: [
      "Orientación tributaria SUNAT",
      "Elección de régimen tributario",
      "Formalización de empresas",
      "Análisis financiero básico"
    ]
  },
  {
    id: 3,
    icon: "User",
    title: "Personas Naturales",
    items: [
      "Declaración de renta",
      "Asesoría para independientes",
      "Revisión de ingresos y gastos"
    ]
  }
];

export const mypesPromoData = {
  label: "Especial MYPES",
  title: "Formalización de MYPES",
  titleAccent: "y cómo gestionarlas con éxito",
  subtitle: "Convierte tu negocio en una empresa formal, competitiva y sostenible.",
  whyTitle: "¿Por qué formalizar tu MYPE?",
  whyItems: [
    {
      icon: "TrendingUp",
      title: "Accede a más oportunidades",
      description: "Postula a créditos, licitaciones y programas de apoyo."
    },
    {
      icon: "ShieldCheck",
      title: "Transmite confianza",
      description: "Genera credibilidad ante tus clientes y proveedores."
    },
    {
      icon: "Users",
      title: "Crece y emplea más",
      description: "La formalización impulsa el crecimiento y la generación de empleo."
    },
    {
      icon: "ClipboardCheck",
      title: "Cumple y evita sanciones",
      description: "Opera dentro de la ley y evita multas o problemas legales."
    }
  ],
  howTitle: "¿Cómo gestionar tu MYPE con éxito?",
  howItems: [
    {
      icon: "Target",
      title: "Planifica",
      description: "Define metas claras y un plan de acción."
    },
    {
      icon: "Calculator",
      title: "Controla tus finanzas",
      description: "Lleva un registro ordenado de ingresos y gastos."
    },
    {
      icon: "HeartHandshake",
      title: "Conoce a tus clientes",
      description: "Ofrece lo que realmente necesitan y dales un buen servicio."
    },
    {
      icon: "Lightbulb",
      title: "Innova y mejora",
      description: "Adáptate al mercado y busca siempre ser mejor."
    }
  ],
  ctaText: "Formalizar tu negocio es el primer paso para construir un futuro de oportunidades.",
  ctaAccent: "¡Da el paso hoy y haz crecer tu MYPE!",
  ctaButton: "Quiero formalizar mi negocio",
  ctaWhatsappMessage: "Hola Eliana, quisiera una asesoría para formalizar mi negocio (MYPE).",
  footerLeft: "Tu esfuerzo, tu negocio, tu futuro.",
  footerRight: "¡Formalízate y gestiona con éxito!"
};

export const processSteps = [
  {
    step: 1,
    title: "Contáctame",
    description: "Te contactas conmigo por WhatsApp o formulario"
  },
  {
    step: 2,
    title: "Evaluación gratuita",
    description: "Evaluamos tu caso sin costo"
  },
  {
    step: 3,
    title: "Documentación digital",
    description: "Enviamos y recibimos documentos de forma digital"
  },
  {
    step: 4,
    title: "Proceso contable",
    description: "Me encargo de todo el proceso contable"
  },
  {
    step: 5,
    title: "Reportes claros",
    description: "Recibes reportes claros y oportunos"
  }
];

export const whyChooseData = {
  title: "¿Por qué elegirme?",
  reasons: [
    "Contadora Pública Colegiada",
    "Experiencia con MYPES y emprendedores",
    "Atención rápida y directa",
    "Servicio 100% remoto",
    "Cumplimiento tributario sin estrés"
  ]
};

export const contactData = {
  title: "Agenda tu asesoría hoy",
  description: "¿Tienes dudas contables o tributarias? Conversemos y encuentra la mejor solución para tu negocio.",
  whatsapp: "+51 950 871 225",
  whatsappNumber: "51950871225",
  email: "roseliana@gmail.com",
  ctaText: "Quiero una asesoría gratuita"
};

export const trustData = {
  title: "Confianza y respaldo",
  items: [
    "Información confidencial",
    "Cumplimiento de normativas vigentes",
    "Trato profesional y transparente"
  ]
};

export const navLinks = [
  { label: "Inicio", href: "#inicio" },
  { label: "Servicios", href: "#servicios" },
  { label: "Proceso", href: "#proceso" },
  { label: "Contacto", href: "#contacto" }
];
